import { createAction } from '@ngrx/store';

export enum SystemActions {
  ToggleMobileMenu = '[System] Toggle Mobile Menu',
}

export const toggleMobileMenu = createAction(SystemActions.ToggleMobileMenu);
